export class Medication {
  units_per_intake?: string;
  firstname?: string;
  strength?: string;
  frequency_of_intake_unit_description?: string;
  date_of_onset?: string;
  brand_name?: string;
  medication_mapping_id?: number;
  version_id?: number;
  duration_unit?: string;
  frequency_of_intake_id?: number;
  lastname?: string;
  duration?: string;
  dt?: string;
  atc?: string;
  pharmaceutical_dose_form?: string;
  active_ingredient_id?: string;
  user_id?: number;
  patient_id?: number;
  pharmaceutical_dose_form_id?: number;
  frequency_of_intake?: string;
  duration_unit_id?: number;
  number_of_intake?: string;
  active_ingredient?: string;
  status?: number;
  [key: string]: any;
}
